import { ButtonColor } from "../buttons/ButtonColor";
import { ButtonInterface } from "../buttons/ButtonInterface";
import { MenuItemBasic } from "./MenuItemBasic";

export class MenuItemRunAnimation extends MenuItemBasic {
  constructor(
    protected override name: string,
    protected override mesh,
    protected override parentMesh,
    protected override type: string,
    protected override button: ButtonInterface = null,
    protected override items: MenuItemBasic[] = [],
    protected target,
    protected direction
  ) {
    super(
      name,
      mesh,
      parentMesh,
      type,
      button,
      items
    );
    this.target = target;
    this.direction = direction;
    // this.button = new ButtonColor(name, color, false, clickable, false, false);
  }

  override maybeChange(message) {
    if (this.target === message["target"]){
      this.click();
      //this.menuItem.clickOnMe(this.menuItem);
    }else{
      this.items.forEach(element => {
        element.maybeChange(message);
      });
    }
  }

}
